import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { ListedDockReservedInterval } from 'contracts/DockReservedIntervals';

const { Types, Creators } = createActions(
  {
    request: ['query', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'LIST_DOCK_RESERVED_INTERVALS_',
  }
);

export interface ListDockReservedIntervalsState {
  data: ListedDockReservedInterval[];
  loading: boolean;
  errorMessage: string | null;
}

export interface ListDockReservedIntervalsRequestAction {
  query?: Record<string, any>;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: ListedDockReservedInterval[];
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: ListDockReservedIntervalsState = {
  data: [],
  loading: false,
  errorMessage: null,
};

const request = (state: ListDockReservedIntervalsState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (
  state: ListDockReservedIntervalsState,
  action: SuccessAction
) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (
  state: ListDockReservedIntervalsState,
  action: FailureAction
) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: ListDockReservedIntervalsState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const listDockReservedIntervals = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const ListDockReservedIntervalsTypes = Types;
export const ListDockReservedIntervalsActions = Creators;
